<template>
<div>
        <v-row>
              <v-col class="" cols="6" sm="8">
                <span 
                  class="font-weight-light grey--text text-capitalize" 
                  :class="{'body-1': $vuetify.breakpoint.xsOnly,'headline': $vuetify.breakpoint.smAndUp}"
                >App Settings</span>
              </v-col>
        </v-row>
        <v-row>
        <FinancialsSettings />
        <RightmoveSettings />
        </v-row>
</div>
</template>

<script>
import RightmoveSettings from '../components/SettingsComponents/RightmoveSettingsComponent'
import FinancialsSettings from '../components/SettingsComponents/FinancialsSettingsComponent'
export default {
  components: {
    RightmoveSettings,
    FinancialsSettings
  },
  data() {
    return {

    }
  }
}
</script>